import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

//const LARAVEL_BASE_URL = 'https://dev.cloudregis.com/checking/laravel/public';
const LARAVEL_BASE_URL = 'http://127.0.0.1:8000/';

const echo = new Echo({
  broadcaster: 'pusher',
  
   //key: 'c065019ebaf8c245ec58', //  this one is for live
  key: 'cca652d35e7c91eccd6e',
  cluster: 'ap2',
  forceTLS: true,
  encrypted: true,
  // authEndpoint: `${LARAVEL_BASE_URL}/api/broadcasting/auth`,
  // auth: {
  //   headers: {
  //     'Authorization': `Bearer ${localStorage.getItem('auth_token') || ''}`,
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json',
  //   },
  // },
});

export default echo;
